import { displayCentsInDollars } from '@vgrubs/components';
import { BarSegment, BarTrack } from './ValueBar.styled';

export type BarSegmentSpec = {
  key: string;
  label: string;
  /** Cents. Nothing is drawn for 0 or less. */
  amount: number;
  color: string;
};

type Props = {
  segments: BarSegmentSpec[];
  /**
   * The amount that fills the whole track: the total the segments make up,
   * or the biggest brand's total so brand bars compare with each other.
   */
  scale: number;
  height?: number;
};

/**
 * What a total is made of, as one stacked bar, a segment per part in a fixed
 * order and colour. The amounts are always written out beside it, so the bar
 * is the shape, not the only record.
 */
export const ValueBar = ({ segments, scale, height = 8 }: Props) => (
  <BarTrack $height={height} role="presentation">
    {scale > 0 &&
      segments
        .filter((segment) => segment.amount > 0)
        .map((segment) => (
          <BarSegment
            key={segment.key}
            $color={segment.color}
            $width={Math.min(100, (segment.amount / scale) * 100)}
            title={`${segment.label}: ${displayCentsInDollars(segment.amount)}`}
          />
        ))}
  </BarTrack>
);
